import { CTAButton } from 'components/CTAButton/CTAButton';
import React from 'react';

import { FAQsView } from '@modules/shared/FAQs/FAQsView';

import { AreasWeCover } from '../AreasWeCover';
import { ListOfServices } from '../ListOfServices';
import { PostCodes } from '../PostCodes';
import { EmergencyComponent } from '../shared/EmergencyComponent';
import { HeroComponent } from '../shared/HeroComponent';
import { ServiceItem } from '../shared/ServiceItem';
import { TitleAndDescComponent } from '../shared/TitleAndDescComponent';
import styles from './WindowDoor.module.scss';

export const WindowDoor = () => {
  return (
    <>
      <HeroComponent
        styles={styles}
        imageLink="/images/services/window-door/Expert_Window_and_Door Fitters.webp"
        imageAlt="Expert window fitter fixing a window"
        title="Window and Door"
      />

      <section className={styles.services}>
        <div className={styles.services_card_block}>
          <div className={styles.container}>
            <div className={styles.inner_section}>
              <TitleAndDescComponent
                styles={styles}
                title="Expert Window and Door Fitters in London"
                description="Professional window and door installation, repair, and replacement services for your home and property. Our local doors and window fittings are designed for quality and durability."
              />
              <CTAButton
                title="Book a Window and Door Fitter"
                serviceName="Windows & Doors"
              />
              <h2></h2>
              <div className={styles.wrap_section}>
                <div className={styles.service_items}>
                  <ServiceItem
                    styles={styles}
                    imgSrc="/images/services/window-door/Window Repairs.webp"
                    imgAlt="Draughty windows with condensation"
                    title="Window and Door Repairs"
                    description="Broken window or door handles? Misaligned locks? Draughty windows? Our team is equipped to handle all types of repairs, including double glazed window repairs and upvc window repairs, effectively and efficiently."
                  />
                  <ServiceItem
                    styles={styles}
                    imgSrc="/images/services/window-door/Door Replacement.webp"
                    imgAlt="Newly replaced front door"
                    title="Window and Door Replacement"
                    description="If your windows or doors are beyond repair, our replacement services offer an ideal solution. We provide high-quality window and door installation, using durable materials to improve both the security and aesthetics of your home."
                  />

                  <ServiceItem
                    styles={styles}
                    imgSrc="/images/services/window-door/uPVC Door.webp"
                    imgAlt="uPVC Door lock"
                    title="uPVC Door and Window Repair"
                    description="Misaligned UPVC door? Faulty locks?  Our skilled professionals specialise in installing and repairing high-quality locks for uPVC doors and windows.  Quality workmanship and the best materials are our priority - to fortify your premises against unauthorised access."
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <EmergencyComponent
        title="Window and Door Repair Near Me"
        imageSrc="/images/services/window-door/Expert_Window_and_Door Fitters.webp"
        imageAlt="Window fitters installing window"
        styles={styles}
        para1="Got a broken window or a damaged door? Our window and door fitters in London are here to help. From installation, repairs or fittings, our experienced team can handle it all with professionalism and efficiency. We specialise in double glazed window repairs, upvc window repairs, and lock services, ensuring your doors and windows are not only stylish but also safe and functional."
      />
      <ListOfServices
        styles={styles}
        serrviceList={[
          { name: 'Tilt & Turn Window Repairs' },
          { name: 'Double Glazing Repairs' },
          { name: 'Misted Glass Repairs' },
          { name: 'Garage Door Lock Repairs' },
          { name: 'Window and Door Repairs' },
          { name: 'Window and Door Replacement' },
          { name: 'uPVC Door and Window Repair' },
        ]}
      />
      <AreasWeCover styles={styles} />
      <PostCodes styles={styles} mainPageUrl="/services/window-door" />
      <FAQsView title="Window and Door FAQs" faqItems={faqItems} />
    </>
  );
};

const faqItems = [
  {
    title: 'How do I know if my windows or doors need repairs?',
    details: `Common signs include difficulty opening or closing, drafts, visible damage, or increased noise. Our team can assess and recommend necessary repairs.`,
  },
  {
    title: 'How long does window or door installation take?',
    details:
      'The installation time varies depending on the size and number of units. Typically, replacing a window or door takes a few hours per unit, ensuring quality and precision.',
  },
  {
    title: 'Can you help with energy efficiency improvements?',
    details: `Absolutely. Our replacement services include energy-efficient windows and doors designed to reduce heat loss, improve insulation, and lower energy bills.`,
  },
  {
    title: 'Can you repair double glazing?',
    details: `Yes, we specialise in double glazed window repairs, including fixing foggy or broken glass and ensuring your windows are energy-efficient.`,
  },
  {
    title: 'How often should windows and doors be maintained?',
    details: `We recommend regular maintenance every 1-2 years to keep your windows and doors in optimal condition, ensuring they remain functional and energy-efficient.`,
  },
];
